(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('dailyR2WReportController', dailyR2WReportController);

  /** @ngInject */
  function dailyR2WReportController ($scope, $translate, reportExportUtil, exportToCsv, DailyR2WReportViewModel, dispatcher, ActionTypesEnum) {
    var vm = this;

    vm.report = new DailyR2WReportViewModel();
    vm.exportToCsv = exportCsv;

    init();

    function init () {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy () {
      vm.report.destroy();
    }

    function exportCsv () {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
          $translate.instant('DATE'),
          vm.report.chart.data,
          reportExportUtil.ValueFormattersEnum.DATE,
          reportExportUtil.ValueFormattersEnum.NUMBER);

      exportToCsv.export(jsonArrayForExport,
          $translate.instant('R2W_BY_DATE_REPORT'),
          true);
    }

  }
})();
